import React, { useState, useEffect } from "react";
import axios from "axios";

import { ItemListResponse } from "helpers/interfaces";
import { TypeInfo } from "helpers/enums";

interface IAssegneeSuggestionsContext {
    suggestions: IAssegneeSuggestions[]
    isLoading: boolean

    setSuggestions: (v: IAssegneeSuggestions[]) => void
    getSuggestions: () => void
    deleteAssegneeSuggestion: (TypeId: string) => Promise<void>
}

export interface IAssegneeSuggestions {
    id: string
    ticketTypeId: TypeInfo
    product: string
    productStatus: string
    assignee: string
}

export let assegneeSuggestionsContext = React.createContext<IAssegneeSuggestionsContext>({} as IAssegneeSuggestionsContext);

let { Provider } = assegneeSuggestionsContext;


let AssegneeSuggestionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [suggestions, setSuggestions] = useState<IAssegneeSuggestions[]>([]);

    useEffect(() => {
        getSuggestions()

    }, [])


    let getSuggestions = async () => {
        try {
            setLoading(true);

            let response = await axios.get<ItemListResponse<IAssegneeSuggestions>>('/api/AssegneeSuggestion/GetAssegneeSuggestions');
            setSuggestions(response.data.items);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let deleteAssegneeSuggestion = async (typeId: string) => {
        if (window.confirm("Are you sure that you want to remove this ticket suggestion?")) {
            try {
                await axios.delete(`/api/AssegneeSuggestion/DeleteAssegneeSuggestion/${typeId}`);
                setSuggestions(suggestions.filter(type => type.id !== typeId));
                getSuggestions()

            } catch (err) { }
        }
    }

    return (
        <Provider value={{
            suggestions,
            isLoading,

            setSuggestions,
            getSuggestions,
            deleteAssegneeSuggestion
        }}>
            {children}
        </Provider>
    );
};

export default AssegneeSuggestionProvider